<script>
import paper from "paper";
import tool from "@/mixins/toolBar/tool";
// import axios from "axios";
import axios from '@/libs/axios'

export default {
  name: "DEXTRTool",
  mixins: [tool],
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      icon: "",
      name: "Prediction",
      cursor: "crosshair",
      settings: {
        padding: 50,
        threshold: 80
      },
      points: []
    };
  },
  methods: {
    
     createPoint(point) {
       let paperPoint = new paper.Path.Circle(point, 5);
       paperPoint.fillColor = this.$parent.currentAnnotation.color;
       paperPoint.data.point = point;
       this.points.push(paperPoint);
     },
     onMouseDown(event) {
       this.createPoint(event.point);
     }
  },
  computed: {
      
//     isDisabled() {
//       return this.$parent.current.annotation == -1;
//     }
  },
  watch: {
     points(
      // newPoints
      ) {
//       if (newPoints.length == 4) {
        //  let points = this.points;
//         this.points = [];

//         let currentAnnotation = this.$parent.currentAnnotation;
        //  let pointsList = [];
//         let width = this.$parent.image.raster.width / 2;
//         let height = this.$parent.image.raster.height / 2;

//         points.forEach(point => {
//           let pt = point.position;

//           pointsList.push([
//             Math.round(width + pt.x),
//             Math.round(height + pt.y)
//           ]);
//         });

        axios
          .post(`/api/model/prediction/${this.$parent.image.id}`);
//       }
     }
  }
};
</script>
